import { render, staticRenderFns } from "./BorrowStatusOption.vue?vue&type=template&id=2a6921ff&scoped=true&"
import script from "./BorrowStatusOption.vue?vue&type=script&lang=js&"
export * from "./BorrowStatusOption.vue?vue&type=script&lang=js&"
import style0 from "./BorrowStatusOption.vue?vue&type=style&index=0&id=2a6921ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6921ff",
  null
  
)

export default component.exports